import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=48e092ff&scoped=true&"
import script from "./js/customer-list.js?vue&type=script&lang=js&"
export * from "./js/customer-list.js?vue&type=script&lang=js&"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=48e092ff&prod&scoped=true&lang=css&"
import style1 from "./customer-list.vue?vue&type=style&index=1&id=48e092ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e092ff",
  null
  
)

export default component.exports